export default "__VITE_ASSET__Cv$XGPgP__"